<template>
  <div>
    <Head title="Create Sku" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/skus">SKUs</Link>
      <span class="text-orange-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2 hidden" label=" Name" />
          <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-full" label="Description" />
          <select-input v-model="form.unit_id" :error="form.errors.unit_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Unit of Measure">
            <option :value="null">
              Select the Unit of Measure
            </option>
            <option
              v-for="unit in units"
              :key="unit.id"
              :value="unit.id"
            >
              {{ unit.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.category_id"
            :error="form.errors.category_id"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Sku Type"
            @change="getChildCategories"
          >
            <option :value="null">
              Select the Type
            </option>
            <option
              v-for="category in types"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.child_category"
            :error="form.errors.child_category"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Category"
          >
            <option :value="null">
              Select the Category
            </option>
            <option
              v-for="category in child_categories"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select-input>
          <text-input v-model="form.standard_quantity" :error="form.errors.standard_quantity" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Standard Quantity" />
          <text-input v-model="form.cbm" :error="form.errors.cbm" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="CBM" />
          <text-input v-model="form.minimum_qty" :error="form.errors.minimum_qty" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Minimum Qantity" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Create SKU</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    units: Object,
    types: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        description: '',
        unit_id: null,
        category_id: null,
        child_category: null,
        standard_quantity: null,
        cbm: null,
        minimum_qty: null,
      }),
      child_categories: [],
    }
  },
  methods: {
    store() {
      this.form.post('/skus')
    },
    getChildCategories() {
      axios.get(`/child-categories/${this.form.category_id}/search`).then(response => {
        this.child_categories = response.data
      })
    },
  },
}
</script>
